module.exports = __webpack_public_path__ + "img/xg.35d7879b.png";